import { render, staticRenderFns } from "./GoodsCheckboxSelect.vue?vue&type=template&id=aea4a5ac"
import script from "./GoodsCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./GoodsCheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports